<template>
  <div
    class="  h-16 cursor-pointer list-group mt-2  w-full flex items-start             flex flex-row justify-center  "
  >
    <div class="flex flex-col items-start w-full   pt-6 bg-gray-100 px-6">
      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm font-medium text-gray-900 "
        >Titre</label>
        <input
          id="default-input"
          v-model="title"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
          @input="onInputTitle"
        >
      </div>
      <div class="  mb-6 w-full text-left">
        <label
          for="default-description-input"
          class="block mb-2 text-lg font-medium text-gray-900 "
        >Description</label>
        <input
          id="default-description-input"
          v-model="description"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
          @input="onInputDescription"
        >
      </div>

      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-lg font-medium text-gray-900 "
        >Format
          de la saisie</label>
        <div class="w-full flex flex-row">
          <div class="ml-3 flex items-center mb-4 w-36">
            <input
              id="default-radio-1"
              v-model="format"
              type="radio"
              value="text"
              name="edit-radio"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500    "
              @change="onInputFormat"
            >
            <label
              for="default-radio-1"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Texte</label>
          </div>


          <div class="ml-3 flex items-center mb-4 w-36">
            <input
              id="default-radio-4"
              v-model="format"
              checked
              type="radio"
              value="integer"
              name="edit-radio"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500    "
              @change="onInputFormat"
            >
            <label
              for="default-radio-2"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Nombre entier</label>
          </div>
          <div class="ml-3 flex items-center mb-4 w-36">
            <input
              id="default-radio-2"
              v-model="format"
              checked
              type="radio"
              value="double"
              name="edit-radio"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500    "
              @change="onInputFormat"
            >
            <label
              for="default-radio-2"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Nombre avec
              virgule</label>
          </div>
          <div class="ml-3 flex items-center mb-4 w-36 hidden">
            <input
              id="default-radio-3"
              v-model="format"
              checked
              type="radio"
              value="time"
              name="edit-radio"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500    "
              @change="onInputFormat"
            >
            <label
              for="default-radio-2"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Heure</label>
          </div>
        </div>
      </div>



      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-lg font-medium text-gray-900 "
        >Attribute</label>
        <input
          :id="`att-input-${element.id}`"
          v-model="data"
          type="text"
          class="w-96 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5      "
          @input="onChangeData"
        >
      </div>
      <div class="  mb-6 w-full text-left">
        <label
          for="template-input"
          class="block mb-2 text-lg font-medium text-gray-900 "
        >Template</label>
        <input
          :id="`att-input-${element.id}`"
          v-model="template"
          type="text"
          class="w-96 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5      "
          @input="onChangeTemplate"
        >
      </div>
      <div class="  mb-6 w-full text-left">
        <label
          for="number-lines-input"
          class="block mb-2 text-lg font-medium text-gray-900 "
        >Hauteur en nombre de lignes</label>
        <input
          :id="`att-input-${element.id}`"
          v-model="number_lines"
          type="text"
          class="w-96 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5      "
          @input="onChangeNumberLines"
        >
      </div>

      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-lg font-medium text-gray-900 "
        >Affichage</label>

        <div class="flex">
          <div class="flex items-center me-4">
            <input
              id="inline-2-checkbox"
              v-model="isTitleDisplayed"
              type="checkbox"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
              @change="onChangeIsTitleDisplayed"
            >
            <label
              for="inline-2-checkbox"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Affichage du Titre</label>
          </div>
          <div class="flex items-center me-4">
            <input
              id="inline-2-checkbox"
              v-model="isDescriptionDisplayed"
              type="checkbox"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
              @change="onChangeIsDescriptionDisplayed"
            >
            <label
              for="inline-2-checkbox"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Affichage de la
              Description</label>
          </div>
          <div class="flex items-center me-4">
            <input
              id="inline-2-checkbox"
              v-model="isDisplayScan"
              type="checkbox"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
              @change="onChangeIsDisplayScan"
            >
            <label
              for="inline-2-checkbox"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Affichage Bouton
              Scan</label>
          </div>


          <div class="w-full flex flex-row ">
            <div class="ml-3 flex items-center mb-4 w-64">
              <label
                for="default-radio-1"
                class="mr-2 text-sm font-medium text-gray-900 "
              >Type</label>

              <select
                id="radio-layout"
                v-model="layout"
                class="w-16 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
                @change="onChangeLayout"
              >
                <option value="automatic">
                  Automatique
                </option>
                <option value="1-0">
                  1 Colonne
                </option>
                <option value="1-1">
                  2 Colonnes 50/50
                </option>
                <option value="2-1">
                  2 Colonnes 66/33
                </option>
                <option value="1-2">
                  2 Colonnes 33/66
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-lg font-medium text-gray-900 "
        >Contraintes</label>

        <div class="flex">
          <div class="flex items-center me-4">
            <input
              id="inline-checked-checkbox"
              v-model="isRequired"
              checked
              type="checkbox"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
              @change="onChangeIsRequired"
            >
            <label
              for="inline-checked-checkbox"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Obligatoire</label>
          </div>
        </div>
      </div>

      <div class="flex items-center me-4 mb-6 border w-full border-t-gray-600 border-t-solid justify-center">
        <button
          class="mt-3 text-white inline-flex w-36 justify-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center   "
          @click="addItem"
        >
          Ajouter
        </button>
      </div>
    </div>
  </div>
</template>


<script>
    export default {
        name: 'EditTableFormComponentDetails',
        props: {
            element: Object
        },
        data() {

            return {
                title: "",
                description: "",
                format: "",
                template: "edit-tpl-1",
                data: "",
                number_lines: 1,
                isDisplayScan: false,
                isRequired: false,
                layout: "1-0",
                isTitleDisplayed: false,
                isDescriptionDisplayed: false,

            }
        },
        watch:
        {
            element: function () {
                this.title = this.element.title;
                this.template = this.element?.template

                this.number_lines = this.element?.number_lines


                this.format = this.element.format;
                this.isRequired = this.element?.isRequired;
                this.isTitleDisplayed = this.element?.isTitleDisplayed;
                this.data = this.element?.data;
                this.isDisplayScan = this.element?.isDisplayScan;
                this.isDescriptionDisplayed = this.element?.isDescriptionDisplayed;
                this.description = this.element?.description;


                this.layout = this.element.layout
                if (this.layout == undefined) this.layout = "1-0"
            }
        },
        mounted() {
            this.title = this.element?.title
            this.template = this.element?.template
            this.format = this.element.format
            this.isRequired = this.element?.isRequired;
            this.isTitleDisplayed = this.element?.isTitleDisplayed;
            this.data = this.element?.data;
            this.isDisplayScan = this.element?.isDisplayScan;
            this.isDescriptionDisplayed = this.element?.isDescriptionDisplayed;
            this.description = this.element?.description;

            this.number_lines = this.element?.number_lines

            this.layout = this.element.layout
            if (this.layout == undefined) this.layout = "1-0"

        },
        methods:
        {


            onChangeNumberLines: function () {
                this.$emit("update", { att: 'number_lines', value: this.number_lines })
            },

            onChangeTemplate: function () {
                this.$emit("update", { att: 'template', value: this.template })
            },
            addItem: function () {
                this.$emit("add", { type: 'avatar', id: this.element.id })
            },
            onChangeData: function () {
                this.$emit("update", { att: 'data', value: this.data })
            },
            onChangeIsTitleDisplayed: function () {
                this.$emit("update", { att: 'isTitleDisplayed', value: this.isTitleDisplayed })
            },
            onChangeIsDescriptionDisplayed: function () {
                this.$emit("update", { att: 'isDescriptionDisplayed', value: this.isDescriptionDisplayed })
            },
            onChangeIsDisplayScan: function () {
                this.$emit("update", { att: 'isDisplayScan', value: this.isDisplayScan })
            },
            onChangeIsRequired: function () {
                this.$emit("update", { att: 'isRequired', value: this.isRequired })
            },
            onChangeLayout: function () {
                this.$emit("update", { att: 'layout', value: this.layout })
            },
            onInputFormat: function () {
                this.$emit("update", { att: 'format', value: this.format })
            },
            onInputTitle: function () {
                this.$emit("update", { att: 'title', value: this.title })
            },
            onInputDescription: function () {
                this.$emit("update", { att: 'description', value: this.description })
            }
        }
    }
</script>